import { Button, Label, Layout } from "@mcleod/components";

export abstract class AutogenLayoutBillOfLadingPanel extends Layout {
    buttonBOL: Button;
    buttonShare: Button;
    labelOrderId: Label;
    labelOrderNumber: Label;
}
